import React, { useEffect, useRef, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useTranslation } from 'react-i18next';

import ButtonComponent from './ButtonComponent.jsx';
import GoogleLogInLink from './GoogleLogInLink.jsx';
import { isValidEmail, postToServer } from './UserUtility.jsx';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

const urlParams = new URLSearchParams(window.location.search);

export default function Registration(props){
  const secretCodeModalRef = useRef();
  const secretCodeModal = useRef();
  const completeRegistrationRef = useRef();
  const completeRegistrationModal = useRef();
  const { t, i18n } = useTranslation();
  const [fullName,setFullName] = useState('');
  const [email,setEmail] = useState(urlParams.get('email'));
  const [password,setPassword] = useState('');
  const [confirmPassword,setConfirmPassword] = useState('');
  const [checkBox,setCheckBox] = useState(false);
  const [fullnameError,setFullnameError] = useState();
  const [emailError,setEmailError] = useState();
  const [passwordError,setPasswordError] = useState();
  const [confirmPasswordError,setConfirmPasswordError] = useState('');
  const [loading,setLoading] = useState(false);
  const [code,setCode] = useState(urlParams.get('code'));
  const [codeError,setCodeError] = useState();
  const [checkBoxError,setCheckBoxError] = useState();
  const [emailDisabled,setEmailDisabled] = useState(Boolean(urlParams.get('email')));
  const {executeRecaptcha} = useGoogleReCaptcha();
  const [phone, setPhoneNumber] = useState()
  const [phoneError,setPhoneError] = useState();

  useEffect(()=>{
    /* eslint-disable */
    secretCodeModal.current = new bootstrap.Modal(secretCodeModalRef.current, {});
    completeRegistrationModal.current = new bootstrap.Modal(completeRegistrationRef.current, {});
    /* eslint-enable */
  },[])

  const onRegistration = e =>{
    if(!code) setCodeError("Secret code is required");
    else if(!phone) setPhoneError("Your phone is required");
    else if(!fullName) setFullnameError("Your name is required");
    else if(!password) setPasswordError("Password is required");
    else if(!confirmPassword) setConfirmPasswordError("Password is required");
    else if(password!=confirmPassword) setConfirmPasswordError("Password mismatch");
    else if(!checkBox) setCheckBoxError("You must accept the Terms and Conditions");
    else{
      setLoading(true);
      postToServer(
        '/user/createAccount', 
        {email,code,fullName,password,phone}
      ).then(result => {
        completeRegistrationModal.current.show()
      }).catch(err=>setCodeError(err.text)).finally(()=>setLoading(false));
    }
  }

  const getRegistrationCode = e => {
    setEmailError(null);
    if(!email) setEmailError(("Email is required"));
    else if (!isValidEmail(email)) setEmailError("Email is incorrect format");
    else {
      setLoading(true);
      executeRecaptcha('register').then(token=>postToServer(
        '/user/getSecretCodeForRegistration', 
        {email,reCaptcha:token}
      ).then(result => {
        setEmailDisabled(true);
        secretCodeModal.current.show()
      }).catch(err=>setEmailError(err.text)).finally(()=>setLoading(false))).catch(err=>{
        alert(err);
        setLoading(false);
      })
    }
  }

  return <div className='d-flex flex-column justify-content-center align-items-center' style={{height:"100%",backgroundImage:`url("/images/login_background.jpg")`,backgroundSize:'100% 100%'}}>
    <div className='d-flex flex-column align-items-center justify-content-center flex-grow-1' style={{width:"360px"}}>
      <h2 className='mb-4 text-center text-capitalize' style={{fontWeight:"bold",color:"var(--vc-darkblue)"}}>{t("account registration")}</h2>
      <div className={`mb-3 d-flex align-items-center justify-content-between input-group form-control border`} >
        <input type="email" className="border-0 flex-grow-1" style={{outline:"none"}} placeholder={t("Email address")} value={email} onChange={e=>{setEmail(e.target.value);setEmailError('')}} 
          onKeyDown={e=>{if(e.key==="Enter") getRegistrationCode(e)}} disabled={emailDisabled}/>
        <span className="material-symbols-outlined" style={{color:'gray'}}>email</span>
      </div>
      {emailError && <p className='d-flex align-items-center' style={{color:"red",width:"100%"}}>
          <span className="material-symbols-outlined me-1" style={{color:"red"}}>error</span>
          {t(emailError)}
        </p>
      }
      {loading?<div className='spinner-grow'></div>:
        (emailDisabled?<span className='text-uppercase text-center'>{t("secret code sent")}</span>:
          <ButtonComponent onClick={getRegistrationCode} label={t(`${t("get")} ${t("Secret code")}`)}/>
        )
      }
      <div className={`my-3 d-flex align-items-center justify-content-between input-group form-control border`} >
        <input className="border-0 flex-grow-1" placeholder={t("Secret code")} style={{outline:"none"}} value={code} onChange={e=>{setCode(e.target.value);setCodeError('')}} disabled={Boolean(urlParams.get('code'))}/>
        <span className="material-symbols-outlined" style={{color:'gray'}}>vpn_key</span>
      </div>
      {codeError && <p className='d-flex align-items-center' style={{color:"red",width:"100%"}}>
          <span className="material-symbols-outlined me-1" style={{color:"red"}}>error</span>
          {t(codeError)}
        </p>
      }
      
      <div className={`mb-3 d-flex align-items-center justify-content-between input-group form-control border`} >
        <PhoneInput
          international
          countryCallingCodeEditable={false}
          defaultCountry="VN"
          value={phone}
          onChange={(value) => {setPhoneNumber(value);setPhoneError('')}} />
        <span className="material-symbols-outlined" style={{color:'gray'}}>phone</span>
      </div>
      {phoneError && <p className='d-flex align-items-center' style={{color:"red",width:"100%"}}>
          <span className="material-symbols-outlined me-1" style={{color:"red"}}>error</span>
          {t(phoneError)}
        </p>
      }

      <div className={`mb-3 d-flex align-items-center justify-content-between input-group form-control border`} >
        <input className="border-0 flex-grow-1" placeholder={t("Your name")} style={{outline:"none"}} value={fullName} onChange={e=>{setFullName(e.target.value);setFullnameError('')}} />
        <span className="material-symbols-outlined" style={{color:'gray'}}>person</span>
      </div>
      {fullnameError && <p className='d-flex align-items-center' style={{color:"red",width:"100%"}}>
          <span className="material-symbols-outlined me-1" style={{color:"red"}}>error</span>
          {t(fullnameError)}
        </p>
      }
      <div className={`mb-3 d-flex align-items-center justify-content-between input-group form-control border`} >
        <input type="password" className="border-0 flex-grow-1" placeholder={t("Password")} style={{outline:"none"}} value={password} onChange={e=>{setPassword(e.target.value);setPasswordError('')}} />
        <span className="material-symbols-outlined" style={{color:'gray'}}>password</span>
      </div>
      {passwordError && <p className='d-flex align-items-center' style={{color:"red",width:"100%"}}>
          <span className="material-symbols-outlined me-1" style={{color:"red"}}>error</span>
          {t(passwordError)}
        </p>
      }
      <div className={`mb-3 d-flex align-items-center justify-content-between input-group border form-control border`}>
        <input type="password" className="border-0 flex-grow-1" style={{outline:"none"}} value={confirmPassword}  onChange={e=>{setConfirmPassword(e.target.value);setConfirmPasswordError('')}} placeholder={t("Retype password")} />
        <span className="material-symbols-outlined" style={{color:'gray'}}>password</span>
      </div>
      {confirmPasswordError && <p className='d-flex align-items-center' style={{color:"red",width:"100%"}}>
          <span className="material-symbols-outlined me-1" style={{color:"red"}}>error</span>
          {t(confirmPasswordError)}
        </p>
      }
      <div style={{width:'100%'}} className='d-flex justify-content-end mb-3'>
        <div className="form-check">
          <input className="form-check-input" type="checkbox" onChange={e=>{setCheckBox(e.target.checked);setCheckBoxError('')}} checked={checkBox}/>
          <label className="form-check-label me-1">
            {t("Agree with")}
          </label>
          <a style={{color:"var(--vc-darkblue)"}} href='/terms-conditions' target='_blank'>
            {t("Terms and Conditions")}
          </a>
        </div>
      </div>
      {checkBoxError && <p className='d-flex align-items-center' style={{color:"red",width:"100%"}}>
          <span className="material-symbols-outlined me-1" style={{color:"red"}}>error</span>
          {t(checkBoxError)}
        </p>
      }
      {loading?<div className='spinner-grow'></div>:
        <ButtonComponent onClick={onRegistration} label={t(`${t("create")} ${t("account")}`)}/>
      }
      <div className='mt-3 d-flex align-items-center justify-content-center'>
          <hr style={{width:"140px"}}/>
          <span className='mx-3' style={{textTransform:"uppercase"}}>{t("or")}</span>
          <hr style={{width:"140px"}}/>
      </div>
      <GoogleLogInLink />
      <div className='mt-3 d-flex flex-row justify-content-center'>
        <span className='me-1'>{t("Already have an account")}?</span>
        <a href="/user/Login" className='text-capitalize'>{t("login")}</a>
      </div>
    </div>
    <div className="modal" tabIndex="-1" ref={secretCodeModalRef} data-bs-backdrop="static" data-bs-keyboard="false">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t("Secret code")} {t("has been emailed to you")}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            {t("Please check your mailbox including the SPAM folder")}.
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button className="btn btn-outline-danger text-uppercase" data-bs-dismiss="modal">{t("close")}</button>
          </div>
        </div>
      </div>
    </div>
    <div className="modal" tabIndex="-1" ref={completeRegistrationRef} data-bs-backdrop="static" data-bs-keyboard="false">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-capitalize">{t("registration completed")}</h5>
          </div>
          <div className="modal-body">
            {t("Please click on the BACK TO LOGIN button to be redirected to login page")}.
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <a className="btn btn-outline-danger text-uppercase" href='/user/Login'>{t("back to")} {t("login")}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
}
